import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import FullCalendarView from '../../component/fullCalendar'
import cleaning_tool from '../../assets/img/svg/cleaning_tool.svg'
import peoole from '../../assets/img/svg/people.svg'
import homes from '../../assets/img/svg/homes_icon.svg'
import RightArrow from '../../assets/img/svg/right-arrow-Icon.svg'
import BarChart from '../../component/dahsboard/barChart'
import { useNavigate } from 'react-router-dom'
import { getMostUsedCoupons, getStatistics, getTopCleanersGraph, getTopClientsGraph } from '../../redux/slices/dashboardSlice'
import { useDispatch, useSelector } from 'react-redux'
import NotificationSection from '../../component/dahsboard/notificationSection'
import FailedPaymentsBanner from '../../component/dahsboard/failedPaymentsBanner'
import { SpinnerContext } from '../../context/spinnerContext'
import {
  convertTimestampToDateWithTimezone,
  convertTimestampToTimeWithTimezone,
  formatBookingForDisplay,
  getBookingDayjs,
  getTimeStamp,
  getUserRole,
  hasAccess
} from '../../helper/function'
import { getAllOverview } from '../../redux/slices/overviewSlice'
import { Dropdown } from 'react-bootstrap'

const Dashboard = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const calendarRef = useRef()
  const { changeLoader } = useContext(SpinnerContext)
  const { allStatistics, allTopCleaners, allTopClients, mostUsedCouponData } = useSelector(({ dashboard }) => dashboard)
  const { allOverview } = useSelector((state) => state.overView)

  const [isRefresh, setIsRefresh] = useState(false)
  const [dateRange, setDateRange] = useState(null)

  // State to manage the dropdown title
  const [dropdownTitle, setDropdownTitle] = useState('Cleanings')

  // Function to handle the title change on item click
  const handleSelect = (eventKey) => {
    setDropdownTitle(eventKey) // Update the title to the selected item's text
  }

  const transformData = (array) => {
    const name = array?.map(({ clientName }) => clientName)
    const jobs = array?.map(({ jobs }) => jobs)

    // If you need exactly 10 items, pad with empty strings and zeros if necessary
    while (name.length < 10) {
      name.push('')
      jobs.push(0)
    }

    return { name, jobs }
  }

  const hostData = useMemo(() => transformData(allTopClients?.clients || []), [allTopClients?.clients])

  const transformCleanerData = (array, dropdownTitle) => {
    const name = array?.map(({ cleanersName }) => cleanersName)
    const jobs = array?.map((item) => (dropdownTitle === 'Rating' ? item.rating : item.jobs))

    // Ensure both arrays have exactly 10 items by padding if necessary
    while (name.length < 10) {
      name.push('')
      jobs.push(0)
    }

    return { name, jobs }
  }

  const cleanersData = useMemo(() => transformCleanerData(allTopCleaners?.cleaners || [], dropdownTitle), [allTopCleaners, dropdownTitle])

  const fetchTopCleaners = useCallback(async () => {
    const isCleaning = dropdownTitle !== 'Rating'
    changeLoader(true)
    try {
      await dispatch(getTopCleanersGraph({ isCleaning }))
    } catch (error) {
      console.error('Error fetching top cleaners:', error)
    } finally {
      changeLoader(false)
    }
  }, [dropdownTitle])

  useEffect(() => {
    fetchTopCleaners()
  }, [fetchTopCleaners])

  const fetchCalendarData = async () => {
    const params = {
      sort_column: 'booking_date_time',
      sort_order: 'DESC',
      ...(dateRange?.start && { startTimestamps: getTimeStamp(dateRange.start) }),
      ...(dateRange?.end && { endTimestamps: getTimeStamp(dateRange.end) })
    }

    changeLoader(true)
    try {
      await dispatch(getAllOverview(params))
    } catch (err) {
      console.error('Error fetching data:', err)
    } finally {
      changeLoader(false)
      setIsRefresh(false)
    }
  }

  useEffect(() => {
    const fetchInitialData = async () => {
      changeLoader(true)
      try {
        await Promise.all([dispatch(getStatistics()), dispatch(getTopClientsGraph()), dispatch(getMostUsedCoupons())])
      } catch (error) {
        console.error('Error fetching initial data:', error)
      } finally {
        changeLoader(false)
      }
    }

    fetchInitialData()
  }, [])

  useEffect(() => {
    fetchCalendarData()
  }, [dateRange, isRefresh])

  const onDatasetChange = useCallback((arg) => {
    setDateRange({ start: arg.view.currentStart, end: arg.view.currentEnd })
  }, [])

  const CALENDAR_EVENT = useMemo(() => {
    if (!allOverview?.scheduledProperties) return []
    return allOverview?.scheduledProperties?.map((overview) => {
      const propertyTz = overview?.properties?.timezone || overview?.property_timezone
      return {
        properties_id: overview?.property_schedule_id,
        title: overview?.properties?.property_name,
        status: overview?.booking_status,
        host_name: `${overview?.properties?.client?.first_name || ''} ${overview?.properties?.client?.last_name || ''}`,
        accepted: overview?.scheduleCleaners ? (overview.scheduleCleaners.is_accepted ? 'Accepted' : 'Declined') : 'Pending',
        checkout: (overview?.booking_wall_clock || overview?.booking_date_time)
          ? formatBookingForDisplay(overview, propertyTz, 'DD MMM YYYY hh:mm A')
          : null,
        next_check_in: overview?.next_checkin_time
          ? `${convertTimestampToDateWithTimezone(overview?.next_checkin_time, propertyTz)} ${convertTimestampToTimeWithTimezone(overview?.next_checkin_time, propertyTz)}`
          : null,
        date: (overview?.booking_wall_clock || overview?.booking_date_time)
          ? getBookingDayjs(overview, propertyTz)?.format('YYYY-MM-DD') || ''
          : '',
        cleaner_name: overview?.cleaners ? `${overview.cleaners.first_name || ''} ${overview.cleaners.last_name || ''}` : null
      }
    })
  }, [allOverview])

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <FailedPaymentsBanner />
          <div className="row deshboard_subdatasec_topbar mb-3 row_gap_div">
            <div className="col-md-6 col-lg-6 col-xl-3 subdatasec_topbar_box">
              <div className="subdatasec_topbar h-100">
                <div>
                  <h4 className="cleanings_month_text">{allStatistics?.cleanersCount}</h4>
                  <h4 className="cleanings_month_subtext"> Cleaners </h4>
                </div>
                <div className="deshboard_topbar_imgsec">
                  <img className="cleaning_tool_img" src={cleaning_tool} alt="cleaning_tool" />
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3 subdatasec_topbar_box">
              <div className="subdatasec_topbar h-100">
                <div>
                  <h4 className="cleanings_month_text">{allStatistics?.clientCount}</h4>
                  <h4 className="cleanings_month_subtext"> Hosts </h4>
                </div>
                <div className="deshboard_topbar_imgsec">
                  <img className="peoole_img" src={peoole} alt="peoole" />
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3 subdatasec_topbar_box">
              <div className="subdatasec_topbar h-100">
                <div>
                  <h4 className="cleanings_month_text">{allStatistics?.propertiesCount}</h4>
                  <h4 className="cleanings_month_subtext"> Properties </h4>
                </div>
                <div className="deshboard_topbar_imgsec">
                  <img className="homes_img" src={homes} alt="homes" />
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3 subdatasec_topbar_box">
              <div className="subdatasec_topbar d-block active_coupon__box_main_div h-100">
                {/* <!-- Active Coupon Card --> */}

                <div className="coupon-section">
                  <div className="coupon-title">Most Used Coupon:</div>
                  {mostUsedCouponData?.mostUsedCoupon?.coupon_code && (
                    <div>
                      <div className="coupon-code">{`${mostUsedCouponData?.mostUsedCoupon?.coupon_code}`}</div>
                      <div className="coupon-applied">Applied {mostUsedCouponData?.mostUsedCoupon?.usageCount} times</div>
                    </div>
                  )}
                </div>

                {hasAccess('dashboardCouponsManageButton', getUserRole()) && (
                  <div className="button-group-coupon">
                    <button className="button-coupon" onClick={() => navigate(`/coupons`)}>
                      Manage All Promotional Coupons
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 col-lg-12 col-xl-8">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="cleanings_month_text fw-bold mb-0"> Calendar</h4>
                <button className="btn btn-primary btn-small" onClick={() => navigate(`/calendar`)}>
                  See More
                </button>
              </div>
              <div className="notification_sec_main mb-3"></div>
              <div className="common_card_div mb-4 dashboard_calender_main_div">
                <FullCalendarView
                  calendarRef={calendarRef}
                  onDatasetChange={onDatasetChange}
                  CALENDAR_EVENT={CALENDAR_EVENT}
                  setIsRefresh={setIsRefresh}
                  maxEventsCount={1}
                />
              </div>
            </div>
            {/* Notification start */}
            <NotificationSection />
            {/* Notification end */}
          </div>
          <div className="row row_gap_div">
            <div className="col-md-12 col-lg-6 col-xl-6">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="cleanings_month_text fw-bold mb-0"> Cleaners</h4>
                <div style={{ cursor: 'pointer' }} onClick={() => navigate(`/cleaners`)}>
                  <img className="homes_img" src={RightArrow} alt="homes" />
                </div>
              </div>
              <div className="notification_sec_main mb-3"></div>
              <div className="common_card_div">
                <div>
                  <div className="chart_header_div">
                    <h3>Top Cleaners</h3>
                    <div className="chart_dropdown_div">
                      <Dropdown onSelect={handleSelect}>
                        <Dropdown.Toggle>By: {dropdownTitle}</Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item eventKey="Cleanings">Cleanings</Dropdown.Item>
                          <Dropdown.Item eventKey="Rating">Rating</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                  <BarChart
                    data={cleanersData}
                    horizontal={true}
                    max={allTopCleaners?.max}
                    seriesName={dropdownTitle === 'Rating' ? 'Rating' : 'Jobs'}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-6 col-xl-6">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="cleanings_month_text fw-bold mb-0"> Hosts</h4>
                <div style={{ cursor: 'pointer' }} onClick={() => navigate(`/clients`)}>
                  <img className="homes_img" src={RightArrow} alt="homes" />
                </div>
              </div>
              <div className="notification_sec_main mb-3"></div>
              <div className="common_card_div">
                <div>
                  <div className="chart_header_div">
                    <h3>Top Hosts</h3>
                  </div>
                  <BarChart data={hostData} max={allTopClients?.max} seriesName={'Jobs'} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Dashboard
